var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 24,
    viewBox: "0 0 43 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1276 10.3964C25.7263 10.0259 25.9884 9.35547 26.5346 9.35547H36.4654C37.0116 9.35547 37.2737 10.0259 36.8724 10.3964L31.907 14.9798C31.6771 15.192 31.3229 15.192 31.093 14.9798L26.1276 10.3964Z",
    fill: "#180171"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.6,
    y: 1.95547,
    width: 39.8,
    height: 19.8,
    rx: 2.4,
    stroke: "#180171",
    strokeWidth: 3.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownNav);
export default __webpack_public_path__ + "static/media/dropdown-nav.33041510.svg";
export { ForwardRef as ReactComponent };